module.exports = __webpack_public_path__ + "img/denmark-blood-diseases-female.1d6b7402.png";